import React, { useState } from 'react';
import { 
  Box, 
  TextField, 
  Button, 
  Typography, 
  Paper, 
  Link, 
  Container,
  Alert
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import httpClient from '../../utils/httpClient';

const ResetPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const fromAccountSettings = location.state?.fromAccountSettings;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');

    // Simple validation
    if (!email) {
      setError('Por favor, informe seu email.');
      return;
    }

    try {
      const res = await httpClient.post(
        '/api/v1/portal/authentication/reset-password-request',
        { emailAddress: email.trim() },
        { headers: { 'X-Skip-Auth': 'true' } }
      );

      // Response may be boolean or wrapped; handle both
      const payload = res?.data;
      const isOk = (typeof payload === 'boolean' && payload === true) || (payload?.success === true && Number(payload?.status) === 200 && payload?.data === true);

      if (isOk) {
        setMessage('Instruções para redefinição de senha foram enviadas para seu email.');
        setEmail('');
      } else {
        const errors = Array.isArray(payload?.errors) ? payload.errors : [];
        const firstErrorMessage = errors[0]?.errorMessage || 'Falha ao solicitar redefinição de senha.';
        setError(firstErrorMessage);
      }
    } catch (err: any) {
      const respData = err?.response?.data;
      let apiError = '';
      if (respData) {
        if (Array.isArray(respData.errors) && respData.errors.length > 0) {
          apiError = respData.errors[0]?.errorMessage || '';
        } else if (typeof respData.message === 'string') {
          apiError = respData.message;
        }
      }
      setError(apiError || 'Erro ao enviar solicitação de redefinição de senha.');
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 2,
            width: '100%',
          }}
        >
          <Typography component="h1" variant="h5" color="primary" sx={{ fontWeight: 'bold', mb: 3 }}>
            Redefinir Senha
          </Typography>
          
          {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
          {message && <Alert severity="success" sx={{ width: '100%', mb: 2 }}>{message}</Alert>}
          
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Informe seu email e enviaremos instruções para redefinir sua senha.
            </Typography>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, bgcolor: 'primary.main' }}
            >
              Enviar Instruções
            </Button>
            <Box sx={{ textAlign: 'center' }}>
              {fromAccountSettings ? (
                <Link
                  component="button"
                  variant="body2"
                  onClick={() => navigate('/imigra-pulse-canada/configuracoes-da-conta')}
                >
                  Voltar
                </Link>
              ) : (
                <Link href="/login" variant="body2">
                  Voltar para o login
                </Link>
              )}
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default ResetPassword;
